///? Default IMPORTS

import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

///? Service IMPORTS
import {
  pickerOrderDetailsThunk,
  saveMissingMedicineDetails,
  // clearPickerDetails,
} from "../../redux/PickerOrder/Action";
import {
  getPickerOrderDetailsThunk,
  getScannedPickerOrderDetailsThunk,
  clearPickerDetails,
} from "../../redux/NewPickerRedux/Action";
import { updatePackageStatusThunk } from "../../redux/packageTrackerRedux/Action";

///? Component & Styling IMPORTS

import {
  PickerWrapper,
  OrderWrapper,
  OrderValue,
  BottomWrap,
  MedsMissing,
  MedDetailsWrap,
  MedSubBtn,
  PickerOuterWrapper,
} from "./PickerOrder.style";
import { Checkbox, Tabs, Input, message, Result, Divider } from "antd";
import "./PickerOrder.css";
import IncrementDecrementInput from "../../components/IncrementDecrementInput/IncrementDecrementInput";
import { PACKAGE_STATUS, warehouseId } from "../../constants/index";
import { ROLES } from "../../constants/index";
import { Dialog } from "@material-ui/core";
import {
  Button,
  DialogTitle,
  DialogActions,
  CircularProgress,
} from "@material-ui/core";
import TitleWrapper from "../../components/TitleWrap/TitleWrap";
import OfflinePage from "../OfflinePage/OfflinePage";
import UserGreeting from "../../components/UserGreeting/UserGreeting";
import { Base64func } from "../../components/Base64Func/Base64func";
import BarcodeScanner from "../../components/BarcodeScanner/BarcodeScanner";
import { AiOutlineScan } from "react-icons/ai";
import MedicineLog from "../../components/MedicineLog/MedicineLog";

///? Constants

const { TabPane } = Tabs;

class PickerOrder extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      orderId: "",
      showMedsMissing: false,
      medicineList: [],
      missingMedList: [],
      missingMedicineDetails: [],
      batchesToSend: [],
      batchesToSendId: [],
      checkList: 0,
      openConfirm: false,
      loaderStatus: false,
      isUserOnline: false,
      // pickerOnline: false,
      showScannerScreen: false,
    };
  }
  componentDidMount = () => {
    // const storedSelectedOption =
    //   JSON.parse(localStorage.getItem("userOnline")) || false;
    // this.setState({ pickerOnline: storedSelectedOption });

    if (
      this.props.userInfo &&
      this.props.userInfo.role &&
      !this.props.userInfo.role.find((o) => o.roleName === ROLES.PICKER_ROLE) &&
      !this.props.userInfo.role.find(
        (o) => o.roleName === ROLES.ADMIN_PICKER_ROLE
      )
    ) {
      message.error("You are not Authorized to access this section.");
      this.props.history.push("/");
    }
    this.props.clearPickerDetails();
  };

  // componentDidUpdate() {
  //   setInterval(() => {
  //     const storedSelectedOption =
  //       JSON.parse(localStorage.getItem("userOnline")) || false;
  //     this.setState({ pickerOnline: storedSelectedOption });
  //   }, 500);
  // }

  sortList = () => {};
  // getPickerDetails = (reload = false) => {
  //   if (!reload) {
  //     message.loading("Loading Details...", 0);
  //   }
  //   let data = {};
  //   let { checkList } = this.state;
  //   data.orderId = this.state.orderId;
  //   data.warehouseId = this.props.userInfo.warehouseIdList[0];
  //   data.access_token = this.props.access_token;
  //   data.history = this.props.history;
  //   this.props.pickerOrderDetailsThunk(data).then(() => {
  //     if (this.props.pickerDetails.pickerOrderDetailsSuccess) {
  //       // this.props.pickerDetails.pickerOrderDetailsSuccess.medicineDetails.map(
  //       //   (item) =>
  //       //     this.props.history.push(
  //       //       `/picker-order-process/orderId=${Base64func(
  //       //         item.orderId,
  //       //         "encode"
  //       //       )}`
  //       //     )
  //       // );

  //       let productCodeList = [];

  //       let productCodeListMed = [];

  //       let missingMedicineDetails = [];

  //       this.props.pickerDetails.pickerOrderDetailsSuccess.missingMedicineDetails.map(
  //         (e) => {
  //           if (!productCodeListMed.includes(e.productCode)) {
  //             productCodeListMed.push(e.productCode);
  //             let tempArray = [];

  //             this.props.pickerDetails.pickerOrderDetailsSuccess.missingMedicineDetails.map(
  //               (f) => {
  //                 if (f.productCode == e.productCode) {
  //                   tempArray.push(f);
  //                 }
  //               }
  //             );

  //             let medicineDetails = {};
  //             medicineDetails.name = e.name;
  //             medicineDetails.productCode = e.productCode;
  //             medicineDetails.orderId = e.orderId;
  //             medicineDetails.batches = tempArray;

  //             missingMedicineDetails.push(medicineDetails);
  //           }
  //         }
  //       );

  //       let medicineList = [];
  //       this.props.pickerDetails.pickerOrderDetailsSuccess.medicineDetails.map(
  //         (e) => {
  //           if (!productCodeList.includes(e.productCode)) {
  //             productCodeList.push(e.productCode);
  //             let tempArray = [];

  //             let activeCount = 0;
  //             this.props.pickerDetails.pickerOrderDetailsSuccess.medicineDetails.map(
  //               (f) => {
  //                 if (f.productCode == e.productCode) {
  //                   let tempDetails = f;
  //                   let ogQty = f.quantity;
  //                   tempDetails.quantity = 0;
  //                   this.props.pickerDetails.pickerOrderDetailsSuccess.missingMedicineDetails.map(
  //                     (g) => {
  //                       if (g.invoiceBatchtId == f.invoiceBatchtId) {
  //                         tempDetails = g;
  //                         activeCount++;
  //                       }
  //                     }
  //                   );
  //                   tempDetails.ogQty = ogQty;
  //                   tempArray.push(tempDetails);
  //                 }
  //               }
  //             );

  //             let medicineDetails = {};
  //             medicineDetails.name = e.name;
  //             medicineDetails.productCode = e.productCode;
  //             medicineDetails.orderId = e.orderId;
  //             medicineDetails.batches = tempArray;
  //             if (activeCount > 0) {
  //               medicineDetails.activeMed = true;
  //               checkList--;
  //             }
  //             medicineList.push(medicineDetails);
  //           }
  //         }
  //       );

  //       checkList = checkList + medicineList.length;
  //       medicineList = medicineList.sort((a, b) =>
  //         a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
  //       );
  //       this.setState({
  //         checkList: checkList,
  //         medicineList: medicineList,
  //         missingMedicineDetails: missingMedicineDetails,
  //       });

  //       message.destroy();
  //       // message.success("Loaded", 1);
  //     } else {
  //       if (reload) {
  //         setTimeout(() => {
  //           this.props.clearPickerDetails();
  //           message.destroy();
  //         }, 1500);
  //       } else {
  //         message.destroy();
  //         if (this.props.pickerDetails.pickerOrderError) {
  //           message.error(this.props.pickerDetails.pickerOrderError);
  //         } else {
  //           message.error("Something went wrong");
  //         }
  //       }
  //     }
  //   });
  // };

  getPickerDetails = (reload = false) => {
    if (!reload) {
      message.loading("Loading Details...", 0);
    }
    let data = {};
    let { checkList } = this.state;
    data.orderId = this.state.orderId;
    data.warehouseId = warehouseId;
    data.access_token = this.props.access_token;
    data.history = this.props.history;
    this.props.getScannedPickerOrderDetailsThunk(data).then(() => {
      if (this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess) {
        message.destroy();
        // this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.medicineDetails.map(
        //   (item) =>
        //     this.props.history.push(
        //       `/picker-order-process/orderId=${Base64func(
        //         item.orderId,
        //         "encode"
        //       )}`
        //     )
        // );

        this.props.history.push(
          `/picker-order-process/orderId=${Base64func(
            this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess
              ?.orderId,
            "encode"
          )}`
        );

        let productCodeList = [];

        let productCodeListMed = [];

        let missingMedicineDetails = [];

        this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.missingMedicineDetails.map(
          (e) => {
            if (!productCodeListMed.includes(e.productCode)) {
              productCodeListMed.push(e.productCode);
              let tempArray = [];

              this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.missingMedicineDetails.map(
                (f) => {
                  if (f.productCode == e.productCode) {
                    tempArray.push(f);
                  }
                }
              );

              let medicineDetails = {};
              medicineDetails.name = e.name;
              medicineDetails.productCode = e.productCode;
              medicineDetails.orderId = e.orderId;
              medicineDetails.batches = tempArray;

              missingMedicineDetails.push(medicineDetails);
            }
          }
        );

        let medicineList = [];
        this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.medicineDetails.map(
          (e) => {
            if (!productCodeList.includes(e.productCode)) {
              productCodeList.push(e.productCode);
              let tempArray = [];

              let activeCount = 0;
              this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.medicineDetails.map(
                (f) => {
                  if (f.productCode == e.productCode) {
                    let tempDetails = f;
                    let ogQty = f.quantity;
                    tempDetails.quantity = 0;
                    this.props.newPickerDetails.newScannedPickerOrderDetailsSuccess.missingMedicineDetails.map(
                      (g) => {
                        if (g.invoiceBatchtId == f.invoiceBatchtId) {
                          tempDetails = g;
                          activeCount++;
                        }
                      }
                    );
                    tempDetails.ogQty = ogQty;
                    tempArray.push(tempDetails);
                  }
                }
              );

              let medicineDetails = {};
              medicineDetails.name = e.name;
              medicineDetails.productCode = e.productCode;
              medicineDetails.orderId = e.orderId;
              medicineDetails.batches = tempArray;
              if (activeCount > 0) {
                medicineDetails.activeMed = true;
                checkList--;
              }
              medicineList.push(medicineDetails);
            }
          }
        );

        checkList = checkList + medicineList.length;
        medicineList = medicineList.sort((a, b) =>
          a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
        );
        this.setState({
          checkList: checkList,
          medicineList: medicineList,
          missingMedicineDetails: missingMedicineDetails,
        });

        message.destroy();
        // message.success("Loaded", 1);
      } else {
        if (reload) {
          setTimeout(() => {
            this.props.clearPickerDetails();
            message.destroy();
          }, 1500);
        } else {
          message.destroy();
          if (this.props.newPickerDetails.newScannedPickerOrderError) {
            message.error(
              this.props.newPickerDetails.newScannedPickerOrderError,
              1
            );
          } else {
            message.error("Something went wrong", 1);
          }
        }
      }
    });
  };

  handleBatchEdit(value, medKey, batchKey) {
    let { batchesToSend, batchesToSendId } = this.state;
    let medicineList = this.state.medicineList;
    medicineList[medKey].batches[batchKey]["quantity"] = value;

    let tempBatchArray = batchesToSend;

    if (
      batchesToSendId.includes(
        medicineList[medKey].batches[batchKey].invoiceBatchtId
      )
    ) {
      batchesToSend[
        batchesToSendId.indexOf(
          medicineList[medKey].batches[batchKey].invoiceBatchtId
        )
      ] = medicineList[medKey].batches[batchKey];
    } else {
      batchesToSend.push(medicineList[medKey].batches[batchKey]);
      batchesToSendId.push(
        medicineList[medKey].batches[batchKey].invoiceBatchtId
      );
    }

    this.setState({
      batchesToSendId: batchesToSendId,
      batchesToSend: tempBatchArray,
      medicineList: medicineList,
    });
  }

  handleChecked(key, value) {
    let medicineList = this.state.medicineList;
    medicineList[key].activeMed = value;
    let checkList = this.state.checkList;

    if (value) {
      checkList--;
    } else {
      checkList++;
      medicineList[key].batches.map((e, i) => {
        if (!e.id) {
          medicineList[key].batches[i].quantity = 0;
        }
      });
    }
    this.setState(
      {
        medicineList: medicineList,
        checkList: checkList,
      },
      () => {
        if (this.state.batchesToSendId.length > 0 && !value) {
          let { batchesToSend, batchesToSendId } = this.state;

          medicineList[key].batches.map((e) => {
            if (batchesToSendId.includes(e.invoiceBatchtId)) {
              batchesToSendId.splice(
                batchesToSendId.indexOf(e.invoiceBatchtId),
                1
              );
              batchesToSend.splice(
                batchesToSendId.indexOf(e.invoiceBatchtId),
                1
              );

              this.setState({
                batchesToSendId,
                batchesToSend,
              });
            }
          });
        }
      }
    );
  }

  saveMeds() {
    let { batchesToSend } = this.state;
    let findZero = 0;
    if (batchesToSend.length > 0) {
      let dataList = [];
      batchesToSend.map((e) => {
        if (!e.id && e.quantity == 0) {
          findZero++;
        }

        let temp = {};
        temp.name = e.name;
        temp.productCode = e.productCode;
        temp.quantity = e.quantity;
        temp.batchNumber = e.batchNumber;
        temp.orderId = e.orderId;
        temp.active = true;
        temp.invoiceBatchtId = e.invoiceBatchtId;
        temp.warehouseId = warehouseId;
        if (e.id) {
          temp.id = e.id;
        }
        if (e.quantity == 0) {
          temp.active = false;
        }
        dataList.push(temp);
      });

      if (findZero > 0) {
        message.error(
          "Quantity 0 found! Please Add quantity or uncheck the medicine"
        );
        return;
      }
      let data = {};
      data.missingMedicineDetailsList = dataList;
      data.access_token = this.props.access_token;
      this.props.saveMissingMedicineDetails(data).then(() => {
        if (this.props.pickerDetails.saveMedsSuccess) {
          message.success(this.props.pickerDetails.saveMedsSuccess);
          this.setState({
            batchesToSendId: [],
            batchesToSend: [],
          });
          // this.getPickerDetails(true);
          this.props.clearPickerDetails();
          this.setState({ orderId: "" });
        } else if (this.props.pickerDetails.saveMedsFailure) {
          message.error(this.props.pickerDetails.saveMedsFailure, 1);
        } else {
          message.error("Something went wrong.", 1);
        }
      });
    } else {
      message.error("Looks like you haven't edited anything yet!", 1);
    }
  }

  handlePicked() {
    this.setState({
      loaderStatus: true,
    });
    if (
      this.state.missingMedicineDetails.length == 0 ||
      this.state.checkList == this.state.medicineList.length ||
      this.props.pickerDetails.pickerOrderDetailsSuccess?.packageStatus !=
        PACKAGE_STATUS.PICKED
    ) {
      message.loading("Saving...", 0);
      let data = {};
      data.awbNoPrinted = false;
      data.boxSource = null;
      data.orderId = this.props.pickerDetails.pickerOrderDetailsSuccess
        ? this.props.pickerDetails.pickerOrderDetailsSuccess.orderId
        : "";
      data.packageStatusId = PACKAGE_STATUS.PICKED; //will be specified
      data.history = this.props.history;
      if (data.orderId) {
        this.props
          .updatePackageStatusThunk(data, this.props.access_token)
          .then(() => {
            message.destroy();
            if (this.props.pdf?.updatePackageSuccess) {
              message.success(this.props.pdf?.updatePackageSuccess?.OK);
              setTimeout(() => {
                window.location.reload();
              }, 1500);
              // this.getPickerDetails(); //  not to be fetched as it will not be fetched in the listing again - omkar
            } else {
              message.error(this.props.pdf?.updatePackageError);
            }
          });
      } else {
        message.error("OrderId Missing", 1);
      }
    }
  }
  handleConfirmClose = () => {
    this.setState({
      openConfirm: false,
    });
  };

  getPickerOrders = () => {
    let data = {
      orderId: this.state.orderId,
      warehouseId: warehouseId,
      access_token: this.props.access_token,
      history: this.props.history,
    };

    this.props.getPickerOrderDetailsThunk(data).then(() => {
      if (this.props.newPickerDetails?.newPickerOrderError) {
        message.error(this.props.newPickerDetails.newPickerOrderError);
      } else if (this.props.newPickerDetails.newPickerOrderDetailsSuccess) {
        this.props.history.push(
          `/picker-order-process/orderId=${Base64func(
            // this.props.newPickerDetails.newPickerOrderDetailsSuccess.orderId,
            this.props.newPickerDetails.newPickerOrderDetailsSuccess,
            "encode"
          )}`
        );
      } else {
        message.error("No orders found!");
      }
    });
  };

  closeScanner = (value) => {
    this.setState({ showScannerScreen: false });
  };

  render() {
    return (
      <PickerOuterWrapper className="centerScreen">
        {this.props.isOnline ? (
          <PickerWrapper>
            <UserGreeting />
            <div>
              <TitleWrapper title={"Order Picker"} />
              <OrderWrapper>
                <div className="inputWrap">
                  <Input
                    type="number"
                    placeholder={"Enter Order Id"}
                    onChange={(e) => {
                      this.setState({
                        orderId: e.target.value,
                      });
                    }}
                    autoFocus
                    value={this.state.orderId}
                    onPressEnter={() => {
                      this.getPickerDetails();
                    }}
                    min={0}
                  />
                </div>
                <div className="btnWrap">
                  <Button
                    onClick={() => {
                      this.getPickerDetails();
                    }}
                  >
                    {"Search"}
                  </Button>
                </div>
              </OrderWrapper>
            </div>

            <Divider>Or</Divider>

            <button className="bbtn" onClick={() => this.getPickerOrders()}>
              Get Orders
            </button>

            <button
              className="bbtn"
              onClick={() => this.setState({ showScannerScreen: true })}
            >
              <AiOutlineScan /> Scan the barcode
            </button>

            {this.state.showScannerScreen && (
              <BarcodeScanner
                scan={this.state.showScannerScreen ? true : false}
                camera={this.state.showScannerScreen ? true : false}
                redirect="pickerUpdate"
                history={this.props.history}
                getBoxId={this.closeScanner}
              />
            )}
            <br />

            <OrderValue>
              {this.props.pickerDetails.pickerOrderDetailsSuccess ? (
                <div className="orderDetailsWrap">
                  <div className="orderDetails">
                    <div className="orderDetailsTitle">{"Order Id: "}</div>
                    <div className="orderDetailsValue">
                      {
                        this.props.pickerDetails.pickerOrderDetailsSuccess
                          .orderId
                      }
                    </div>
                  </div>
                  <div className="orderDetails">
                    <div className="orderDetailsTitle">{"Customer Name: "}</div>
                    <div className="orderDetailsValue">
                      {
                        this.props.pickerDetails.pickerOrderDetailsSuccess
                          .customerName
                      }
                    </div>
                  </div>
                  <div className="orderDetails">
                    <div className="orderDetailsTitle">{"Invoice Date: "}</div>
                    <div className="orderDetailsValue">
                      {
                        this.props.pickerDetails.pickerOrderDetailsSuccess
                          .invoiceDate
                      }
                    </div>
                  </div>
                  <div className="orderDetails">
                    <div className="orderDetailsTitle">{"Payment Type: "}</div>
                    <div className="orderDetailsValue">
                      {
                        this.props.pickerDetails.pickerOrderDetailsSuccess
                          .paymentType
                      }
                    </div>
                  </div>
                  <div className="orderDetails">
                    <div className="orderDetailsTitle">{"Order Value: "}</div>
                    <div className="orderDetailsValue">
                      {"₹" +
                        this.props.pickerDetails.pickerOrderDetailsSuccess
                          .orderValue}
                    </div>
                  </div>
                </div>
              ) : (
                ""
              )}
            </OrderValue>
            {this.props.pickerDetails.pickerOrderDetailsSuccess ? (
              <React.Fragment>
                <MedsMissing>
                  <Tabs defaultActiveKey="1">
                    <TabPane tab="Medicine Details" key="1">
                      {this.state.medicineList.length > 0 ? (
                        <div>
                          {this.state.medicineList.map((e, i) => {
                            return (
                              <MedDetailsWrap>
                                <div className="medTitleWrap">
                                  <Checkbox
                                    checked={e.activeMed}
                                    onChange={(f) => {
                                      this.handleChecked(i, !e.activeMed);
                                    }}
                                  >
                                    <div className="medTitle">{e.name}</div>
                                  </Checkbox>
                                </div>
                                <div className="batchWrap">
                                  {e.batches.length > 0 ? (
                                    e.batches.map((f, j) => {
                                      return (
                                        <div className="batchDetailsWrap">
                                          <div className="name">
                                            {f.batchNumber}
                                          </div>
                                          <div className="qty">{f.ogQty}</div>
                                          <div className="editQty">
                                            {/* <InputNumber
                                          addonBefore={"-"}
                                          addonAfter={"+"}
                                          disabled={!e.activeMed}
                                          min={0}
                                          max={f.ogQty}
                                          value={f.quantity}
                                          onChange={(e) => {
                                            this.handleBatchEdit(e, i, j);
                                          }}
                                        /> */}
                                            <div>
                                              <IncrementDecrementInput
                                                disabled={!e.activeMed}
                                                min={0}
                                                max={f.ogQty}
                                                value={f.quantity}
                                                step={1}
                                                handleChange={(e) => {
                                                  this.handleBatchEdit(e, i, j);
                                                }}
                                              />
                                            </div>
                                          </div>
                                        </div>
                                      );
                                    })
                                  ) : (
                                    <div>{"No Batches Found"}</div>
                                  )}
                                </div>
                              </MedDetailsWrap>
                            );
                          })}
                          <MedSubBtn
                            className={
                              this.state.batchesToSendId.length == 0
                                ? "btnDisabled"
                                : ""
                            }
                            disabled={
                              this.state.batchesToSendId.length == 0
                                ? true
                                : false
                            }
                            onClick={() => {
                              this.saveMeds();
                            }}
                          >
                            {"Submit"}
                          </MedSubBtn>
                        </div>
                      ) : (
                        <div className="medError">{"No Medicines Found"}</div>
                      )}
                    </TabPane>
                  </Tabs>
                </MedsMissing>

                <BottomWrap
                  className={
                    this.state.missingMedicineDetails.length > 0 ||
                    this.props.pickerDetails.pickerOrderDetailsSuccess
                      ?.packageStatus == PACKAGE_STATUS.PICKED ||
                    this.state.checkList < this.state.medicineList.length
                      ? " disabled"
                      : ""
                  }
                  onClick={() => {
                    this.setState({
                      openConfirm: true,
                    });
                  }}
                >
                  <div className={"right"}>{"Picked"}</div>
                </BottomWrap>
              </React.Fragment>
            ) : (
              ""
            )}
            <Dialog
              open={this.state.openConfirm}
              onClose={() => {
                this.handleConfirmClose();
              }}
              fullWidth={true}
              maxWidth={"lg"}
            >
              <DialogTitle>{"Are you sure?"}</DialogTitle>
              <DialogActions>
                <Button
                  onClick={() => {
                    this.handleConfirmClose();
                  }}
                  color="primary"
                >
                  Close
                </Button>
                <Button
                  onClick={() => this.handlePicked()}
                  variant="contained"
                  color="primary"
                  disabled={this.state.loaderStatus}
                >
                  {this.state.loaderStatus ? (
                    <CircularProgress size={20} />
                  ) : (
                    "Yes"
                  )}
                </Button>
              </DialogActions>
            </Dialog>
          </PickerWrapper>
        ) : (
          <OfflinePage />
        )}
      </PickerOuterWrapper>
    );
  }
}

const mapStateToProps = (state) => ({
  access_token: state.authReducer?.AuthData?.data?.access_token,
  userInfo: state.authReducer?.AuthData?.userDTO,
  pickerDetails: state.pickerorderReducer,
  newPickerDetails: state.newPickerOrderReducer,
  pdf: state.packageTrackerReducer,
  isOnline: state.statusReducer?.isOnline,
});

export default withRouter(
  connect(mapStateToProps, {
    pickerOrderDetailsThunk,
    saveMissingMedicineDetails,
    updatePackageStatusThunk,
    clearPickerDetails,
    getPickerOrderDetailsThunk,
    getScannedPickerOrderDetailsThunk,
  })(PickerOrder)
);
